import axios from 'axios';
import { authenticationContext } from './authenticationContext';

const client = axios.create();

export const configure = callback => {
    callback(client);
}

const request = async (options) => {
    const currentUser = authenticationContext.currentUserValue;

    let headers = new Object();
    if (currentUser && currentUser.token) {
        headers['Authorization'] = `Bearer ${currentUser.token}`;
    }
    if (options.method.toLowerCase() == 'post') {
        headers['Content-Type'] = 'application/json;charset=UTF-8';
    }
    if (headers)
       options.headers = Object.assign(headers, options.headers);

    try {
        var result = await client(options);
        return result.data || result;
    }
    catch (error) {
        let message;

        if (error.response) {
            message = `Server responded with error status: ${error.response}`;
        }
        else {
            message = `Error sending request: ${error.message}`;
        }
        console.log(message);
        return Promise.reject(error);
    }
}

export default request;